import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiEndpointsService } from './api-endpoints.service';
import { IHttpService } from './ihttp.service';
import { share } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FilterSelection } from '../classes/filterSelection';
import { UserSSOModel } from '../classes/userSSO';

@Injectable()
export class DataService {
  private filtersVisible: boolean = false;
  private filtersVisible$ = new BehaviorSubject<boolean>(this.filtersVisible);

  private mapUp: boolean = true;
  private mapUp$ = new BehaviorSubject<boolean>(this.mapUp);

  private countPosWarnings: Number = 0;
  private countPosWarnings$ = new BehaviorSubject<Number>(
    this.countPosWarnings
  );
  private userInfo: any = {};
  private userInfo$ = new BehaviorSubject<any>(null);

  private isAdmin: boolean = false;
  private isTam: boolean = false;
  private isSuperViewer: boolean = false;

  private tokenSAP: any = {};
  private tokenSAP$ = new BehaviorSubject<any>(null);
  private hasMemberResults: boolean = false;

  private isLoaded: boolean = false;

  private filter = new FilterSelection();
  private filterState$ = new BehaviorSubject<FilterSelection>(this.filter);

  private sapId: string = '';

  private userSSO$ = new BehaviorSubject<UserSSOModel | null>(null);

  constructor(
    private apiEndpointsService: ApiEndpointsService,
    @Inject('HttpService') private httpService: IHttpService,
    private router: Router
  ) { }

  public getFiltersVisible$ = () => this.filtersVisible$.asObservable();
  public getMapUp$ = () => this.mapUp$.asObservable();
  public getCountPosWarnings$ = () => this.countPosWarnings$.asObservable();
  public getUserInfo$ = () => this.userInfo$.asObservable();
  public getTokenSAP$ = () => this.tokenSAP$.asObservable();
  public getUserSSO$ = () => this.userSSO$.asObservable();

  public sendShowHideFilters = () => {
    this.filtersVisible = this.filtersVisible ? false : true;
    this.filtersVisible$.next(this.filtersVisible);
  };

  public sendChangeMapPosition = () => {
    this.mapUp = this.mapUp ? false : true;
    this.mapUp$.next(this.mapUp);
  };

  public sendRefreshPosWarningsCount = () => {
    //console.log(this.apiEndpointsService.getPosAlertsCountEndpoint());
    this.httpService
      .get(this.apiEndpointsService.getPosAlertsCountEndpoint())
      //.pipe(share())
      .subscribe((data) => {
        this.countPosWarnings = new Number(data);
        this.countPosWarnings$.next(this.countPosWarnings);
      });
  };

    setUserSSO(user: UserSSOModel) {
    this.userSSO$.next(user);
  }
  
  public setTokenSAP(token: any) {
    this.tokenSAP = token;
    this.tokenSAP$.next(token);
  }

  public getTokenSAP() {
    return this.tokenSAP;
  }

  public setResultFromMembers(hasResult: boolean) {
    this.hasMemberResults = hasResult;
  }

  public getResultFromMembers(): boolean {
    return this.hasMemberResults;
  }

  public setUserInfo(userInfo: any) {
    this.userInfo = userInfo;
    if (
      this.userInfo != null &&
      this.userInfo.firstName != null &&
      this.userInfo.lastName != null
    ) {
      this.httpService
        .get(
          this.apiEndpointsService.getExistTamEndpoint(this.sapId)
        )
        .subscribe((data) => {
          if (data != null) {
            //console.log(' result of is TAM ');
            //console.log(data);
            if (data.value[0] != null && data.value[0].TAM != '') {
              this.isAdmin = false;
              this.isSuperViewer = false;
              this.isTam = true;
              console.log('---------- is Tam');
            } else {
              //pending to make call for know if user is in AMDIN_GROUP
              // by the moment
              this.isAdmin = this.hasMemberResults ? true : false;
              this.isSuperViewer = !this.hasMemberResults ? true : false;
              this.isTam = false;
            }
            this.userInfo$.next(userInfo);
          }
        });
    }
  }
  public getUserInfo(): any {
    return this.userInfo;
  }
  //this function is called before make OData queries to determine if
  //needs apply the tamName filter.
  public getTamName(): string {
    let tamName = '';
    //only return value if user is not admin and not superviewer
    if (this.userInfo != null && this.userInfo != undefined && this.isTam) {
      tamName = this.userInfo.lastName + ', ' + this.userInfo.firstName;
    }
    return tamName;
  }

  public getIsSuperViewer(): boolean {
    return this.isSuperViewer;
  }

  public isDetail(): boolean {
    return this.router.url.indexOf('detail', 0) > 0 ? true : false;
  }

  public getIsLoaded(): boolean {
    return this.isLoaded;
  }

  public setIsLoaded(isLoaded: boolean) {
    this.isLoaded = isLoaded;
  }

  public getFilterState(): Observable<FilterSelection> {
    return this.filterState$.asObservable();
  }

  public setFilterState(filterState: FilterSelection) {
    this.filterState$.next(filterState);
  }

  public getSapId(): string {
    return this.sapId;
  }

  public setSapId(sapId: string) {
    this.sapId = sapId;
  }

}
